var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Karte__Icn/40px/Karte",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Karte__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Karte__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,10 C32.1045695,10 33,10.8954305 33,12 L33,28 C33,29.1045695 32.1045695,30 31,30 L10,30 C8.8954305,30 8,29.1045695 8,28 L8,12 C8,10.8954305 8.8954305,10 10,10 Z M9.79928392,20.1699933 L9.8,28.1818182 L15.775,28.181 L13.1674914,17.7040172 C11.1873628,18.1406805 10.1030296,18.9760372 9.79928392,20.1699933 Z M31.2,20.124 L25.537,21.434 L27.288,28.181 L31.2,28.1818182 L31.2,20.124 Z M23.787,21.839 L16.469,23.532 L17.626,28.181 L25.433,28.181 L23.787,21.839 Z M21.186,11.818 L20.7057504,11.8190913 C20.9016196,15.0398979 19.3445009,16.9987569 15.3398126,17.4049803 L15.0787289,17.4289745 L14.952,17.439 L16.028,21.761 L23.328,20.072 L21.186,11.818 Z M31.2,11.8181818 L23.041,11.818 L25.078,19.667 L31.2,18.251 L31.2,11.8181818 Z M11.703,11.818 L9.8,11.8181818 L9.79826644,17.1729967 C10.5573345,16.6196382 11.5381815,16.2090113 12.7289103,15.9369757 L11.703,11.818 Z M18.925232,11.8194544 L13.553,11.818 L14.5062994,15.6489196 C14.5461098,15.6447334 14.58609,15.6406608 14.6262397,15.6367016 L14.9337716,15.6088644 C17.9756423,15.357609 19.1085301,14.2076828 18.925232,11.8194544 Z",
    id: ".._.._src_svg_Icn_40px_Karte__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarte);
export default __webpack_public_path__ + "static/media/Karte.62f6eca45ae544ec9aef518d5ce938ea.svg";
export { ForwardRef as ReactComponent };